import * as React from 'react'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { Loader } from 'shared/components/Loader'
import { IApplicationState } from 'redux/store/store'
import { ExportToCsv } from 'export-to-csv-fix-source-map'
import {
  IGetLocationsResponseAction,
  getLocationsActionCreator,
  clearDataActionCreator,
  IClearDataResponseAction,
} from 'redux/store/actions/glnLocatieZoekAction'
import { useState } from 'react'
import 'react-day-picker/lib/style.css'
import 'moment/locale/nl'
import { IGlnLocatieZoekSelectie } from 'shared/models/IGlnLocatieZoekSelectie'
import { IKlantKoppelingMetLocatieExcelModel } from 'shared/models/IKlantKoppelingMetLocatieExcelModel'
import { exceloptions, VestigingEnum, KoppelingType } from 'shared/models/Enum'
import {
  comparableDate,
  formatDate,
  getDaysDisplay,
} from 'shared/service/helpers/DateUtilities'
import CustomerLocationLinkSearchBox from 'shared/components/CustomerLocationLinks/CustomerLocationLinkSearchBox'
import { ICustomerLocationLinks } from 'shared/models/CustomerLocationLinks/ICustomerLocationLinks'
import { ILocationModel } from 'shared/models/CustomerLocationLinks/ILocationModel'

interface IProps {
  requestData: (
    selectie: IGlnLocatieZoekSelectie
  ) => Promise<IGetLocationsResponseAction>
  clearData: (message: string) => Promise<IClearDataResponseAction>
  locaties: ILocationModel[]
  schermloading: boolean
  foutmelding: string
}

const GlnLocatieZoekLijst: React.FunctionComponent<IProps> = ({
  requestData,
  clearData,
  locaties,
  schermloading,
  foutmelding,
}) => {
  const [sortedData, setSortedData] = useState([])
  const re = /^[0-9\b]+$/

  const sortSubResults = (type, list: ICustomerLocationLinks[]) => {
    const types = {
      klantNummer: 'klantAfleverafspraak.klant.klantNummer',
      klantNaam: 'klantAfleverafspraak.klant.klantNaam',
      afleverafspraakReferentie:
        'klantAfleverafspraak.afleverafspraakReferentie',
      koppelingType: 'koppelingType',
      orderTypes: 'orderTypes',
      dagen: 'dagen',
      combinatie: 'combinatie',
      ingangsDatum: 'ingangsDatumtijd',
      eindDatum: 'eindDatumtijd',
    }
    const sortProperty = types[type]
    console.log(`Sorteren op ${sortProperty}`)
    if (list !== undefined && list.length !== 0) {
      let sortedLocaties: ICustomerLocationLinks[]
      const startArray =
        sortedLocaties == undefined ? [...list] : sortedLocaties
      if (sortProperty == 'eindDatumtijd') {
        sortedLocaties = list.sort(function (a, b) {
          let datumStringA = comparableDate(`${a.eindDatumtijd}`)
          let datumStringB = comparableDate(`${b.eindDatumtijd}`)
          if (datumStringA == datumStringB) {
            return b.klantNummer - a.klantNummer
          }
          return datumStringA > datumStringB ? 1 : -1
        })
      } else {
        sortedLocaties = list.sort((a, b) =>
          a[sortProperty] > b[sortProperty] ? 1 : -1
        )
      }
      if (JSON.stringify(startArray) != JSON.stringify(sortedLocaties)) {
        list = sortedLocaties
        setSortedData([...sortedLocaties])
      } else {
        setSortedData([...sortedLocaties.reverse()])
      }
    } else {
      clearData('Geen resultaten beschikbaar!')
    }
  }

  const sortResultsLocaties = type => {
    const types = {
      locatieGlnNaam: 'locatieGlnNaam',
      locatieGlnOmschrijving: 'locatieGlnOmschrijving',
      locatieGlnCode: 'locatieGlnCode',
    }
    const sortProperty = types[type]
    console.log(`Sorteren op ${sortProperty}`)
    if (locaties !== undefined && locaties.length !== 0) {
      let sortedLocaties: ILocationModel[]
      const startArray =
        sortedLocaties == undefined ? [...locaties] : sortedLocaties
      sortedLocaties = locaties.sort((a, b) =>
        a[sortProperty] > b[sortProperty] ? 1 : -1
      )
      if (JSON.stringify(startArray) != JSON.stringify(sortedLocaties)) {
        locaties = sortedLocaties
        setSortedData([...sortedLocaties])
      } else {
        setSortedData([...sortedLocaties.reverse()])
      }
    } else {
      clearData('Geen resultaten beschikbaar!')
    }
  }

  const zoekOpNaamExportToCsv = () => {
    let lijst: Array<IKlantKoppelingMetLocatieExcelModel> =
      [] as Array<IKlantKoppelingMetLocatieExcelModel>
    locaties.forEach(function (x) {
      if (x.koppelingen.length < 1) {
        var geenKoppelingen: IKlantKoppelingMetLocatieExcelModel = {
          klantNummer: null,
          klantNaam: '',
          afleverafspraakReferentie: '',
          afleverafspraakNaam: '',
          orderTypes: '',
          dagen: '',
          combinatie: '',
          locatieGlnCode: x.locatieGlnCode,
          locatieNaam: x.locatieGlnNaam,
          locatieOmschrijving: x.locatieGlnOmschrijving,
          ingangsDatum: '',
          eindDatum: '',
        }
        lijst.push(geenKoppelingen)
      } else {
        x.koppelingen.forEach(function (y) {
          lijst.push({
            klantNummer: y.klantNummer,
            klantNaam: y.klantNaam,
            afleverafspraakReferentie: y.afleverAfspraakReferentie,
            afleverafspraakNaam: y.afleverAfspraakNaam,
            orderTypes: y.orderTypes,
            dagen: y.dagen,
            combinatie: y.combinatie,
            locatieGlnCode: x.locatieGlnCode,
            locatieNaam: x.locatieGlnNaam,
            locatieOmschrijving: x.locatieGlnOmschrijving,
            ingangsDatum: `${formatDate(y.ingangsDatumtijd)}`,
            eindDatum: `${formatDate(y.eindDatumtijd)}`,
          } as IKlantKoppelingMetLocatieExcelModel)
        })
      }
    })
    const csvExporter = new ExportToCsv(exceloptions)
    csvExporter.generateCsv(lijst)
  }

  const renderKoppelingenRows = (data: ICustomerLocationLinks[]) => {
    return data.map(x => {
      return (
        <tr>
          <td>{x.klantNummer}</td>
          <td className='mw-200 overflow-hidden' title={x.klantNaam}>
            {x.klantNaam}
          </td>
          <td>{x.afleverAfspraakReferentie}</td>
          <td>{KoppelingType[x.koppelingType]}</td>
          <td>{x.orderTypes != '30,32,33,34,50' ? x.orderTypes : 'Alle'}</td>
          <td>{x.dagen != null ? getDaysDisplay(x.dagen) : ''}</td>
          <td>{x.combinatie}</td>
          <td>{formatDate(x.ingangsDatumtijd)}</td>
          <td>{formatDate(x.eindDatumtijd)}</td>
        </tr>
      )
    })
  }

  const renderLocaties = (data: ILocationModel[]) => {
    return data.map(x => {
      return (
        <React.Fragment>
          <tr>
            <td>{x.locatieGlnCode}</td>
            <td>{x.locatieGlnNaam}</td>
            <td>{x.locatieGlnOmschrijving}</td>
            <td>{VestigingEnum[x.vestigingCode]}</td>
          </tr>
          {x.koppelingen != null && x.koppelingen.length > 0 && (
            <tr>
              <td colSpan={4}>
                <table className='mw-100'>
                  <tr className='tablesubheader'>
                    <td>
                      <button
                        className='sortheader'
                        onClick={() =>
                          sortSubResults('klantNummer', x.koppelingen)
                        }
                      >
                        Klantnr.
                      </button>
                    </td>
                    <td>
                      <button
                        className='sortheader'
                        onClick={() =>
                          sortSubResults('klantNaam', x.koppelingen)
                        }
                      >
                        Klantnaam
                      </button>
                    </td>
                    <td>
                      <button
                        className='sortheader'
                        onClick={() =>
                          sortSubResults(
                            'afleverafspraakReferentie',
                            x.koppelingen
                          )
                        }
                      >
                        AAR
                      </button>
                    </td>
                    <td>
                      <button
                        className='sortheader'
                        onClick={() =>
                          sortSubResults('koppelingType', x.koppelingen)
                        }
                      >
                        Type
                      </button>
                    </td>
                    <td>
                      <button
                        className='sortheader'
                        onClick={() =>
                          sortSubResults('orderTypes', x.koppelingen)
                        }
                      >
                        Ordertype
                      </button>
                    </td>
                    <td>
                      <button
                        className='sortheader'
                        onClick={() => sortSubResults('dagen', x.koppelingen)}
                      >
                        Dagen
                      </button>
                    </td>
                    <td>
                      <button
                        className='sortheader'
                        onClick={() =>
                          sortSubResults('combinatie', x.koppelingen)
                        }
                      >
                        Code Combinatie
                      </button>
                    </td>
                    <td>
                      <button
                        className='sortheader'
                        onClick={() =>
                          sortSubResults('ingangsDatum', x.koppelingen)
                        }
                      >
                        Ingangsdatum
                      </button>
                    </td>
                    <td>
                      <button
                        className='sortheader'
                        onClick={() =>
                          sortSubResults('eindDatum', x.koppelingen)
                        }
                      >
                        Einddatum
                      </button>
                    </td>
                  </tr>
                  {renderKoppelingenRows(x.koppelingen)}
                </table>
              </td>
            </tr>
          )}
          <tr>
            <td colSpan={4}>
              <hr />
            </td>
          </tr>
        </React.Fragment>
      )
    })
  }

  return (
    <div>
      <h2>Zoek klant-locatie koppelingen</h2>

      <div>
        {schermloading && (
          <div>
            <Loader show={true} />
          </div>
        )}
        <CustomerLocationLinkSearchBox
          searchLocations={requestData}
          clearData={clearData}
        />
      </div>

      {!!foutmelding && (
        <div className='alert alert-danger maxedbox'>{foutmelding}</div>
      )}
      {locaties != null && locaties.length > 0 && (
        <div>
          <table className='selectie widetable1340'>
            <thead>
              <tr>
                <th colSpan={4} className='selectie-label'>
                  <div className='row'>
                    <div className='col-auto'>Locaties</div>
                    <div className='col-auto'>
                      <button
                        className='btn btn-info'
                        onClick={zoekOpNaamExportToCsv}
                      >
                        Excel
                      </button>
                    </div>
                    <div className='col'></div>
                  </div>
                </th>
              </tr>
              <tr>
                <th colSpan={4}>
                  <hr />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className='tablesubheader'>
                <td>
                  <button
                    className='toplevelsortheader'
                    onClick={() => sortResultsLocaties('locatieGlnCode')}
                  >
                    GLN-code
                  </button>
                </td>
                <td>
                  <button
                    className='toplevelsortheader'
                    onClick={() => sortResultsLocaties('locatieGlnNaam')}
                  >
                    Locatie Naam
                  </button>
                </td>
                <td>
                  <button
                    className='toplevelsortheader'
                    onClick={() =>
                      sortResultsLocaties('locatieGlnOmschrijving')
                    }
                  >
                    Locatie Omschrijving
                  </button>
                </td>
                <td>
                  <button
                    className='toplevelsortheader'
                    onClick={() => sortResultsLocaties('vestiging')}
                  >
                    Vestiging
                  </button>
                </td>
              </tr>

              {renderLocaties(locaties)}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (store: IApplicationState) => {
  return {
    schermloading: store.glnLocatieZoekState.loading,
    locaties: store.glnLocatieZoekState.locaties,
    foutmelding: store.glnLocatieZoekState.foutmelding,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    requestData: (selectie: IGlnLocatieZoekSelectie) =>
      dispatch(getLocationsActionCreator(selectie)),
    clearData: (message: string) => dispatch(clearDataActionCreator(message)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GlnLocatieZoekLijst)
